export const calculateFitpassValue = (fitpassRate, fitpassQuantity) => {
    if (!fitpassRate || !fitpassQuantity) {
        return 0;
    }

    return parseFloat(fitpassRate) * parseInt(fitpassQuantity);
};

